import { initContract } from '@ts-rest/core';

export const c = initContract();
